// Extracted from sections/main-product.liquid (H6). Pure JS, no Liquid.
// Loaded once, deferred, cached across product pages.

// [1] Related-products tabs + clicked-product highlight (highlightClickedProduct is global; used by inline onclick)
    function highlightClickedProduct(element) {
      var previouslyClicked = document.querySelector('.clickable-product.clicked');
      if (previouslyClicked) {
        previouslyClicked.classList.remove('clicked');
        previouslyClicked.querySelector('img').style.border = '1px solid #e6ddcf';
      }
      var currentProduct = document.getElementById('current-product');
      if (currentProduct) {
        currentProduct.querySelector('img').style.border = '1px solid #e6ddcf';
      }
      element.classList.add('clicked');
      element.querySelector('img').style.border = '3px solid #0d245a';

      // Save gallery scroll position before navigating to the new product page, plus where the
      // tapped swatch sat in the strip: the next page lines its own swatch up there, because the
      // two strips can differ by a swatch (a sold-out page keeps its own swatch; owner 2026-10-24).
      try {
        var gallery = document.getElementById('product-gallery');
        if (gallery) {
          sessionStorage.setItem('relatedGalleryScroll', gallery.scrollLeft);
          var tapped = element.closest('.related-product-item');
          if (tapped) {
            sessionStorage.setItem('relatedTappedOffset', tapped.getBoundingClientRect().left - gallery.getBoundingClientRect().left);
          } else {
            sessionStorage.removeItem('relatedTappedOffset');
          }
        }
        sessionStorage.setItem('relatedNavTarget', new URL(element.href, location.origin).pathname);
      } catch(e) {}
    }

    (function() {
      function initRelatedTabs() {
        var tabBtns = document.querySelectorAll('.related-tab-btn');
        var items = document.querySelectorAll('.related-product-item');
        if (!tabBtns.length || !items.length) return;

        function applyTab(tab) {
          items.forEach(function(item) {
            var isBs = item.getAttribute('data-bestseller') === 'true';
            var isSale = item.getAttribute('data-sale') === 'true';
            var isNew = item.getAttribute('data-new') === 'true';
            var isLimited = item.getAttribute('data-limited') === 'true';
            if (tab === 'bestsellers') {
              item.style.display = isBs ? '' : 'none';
            } else if (tab === 'sale') {
              item.style.display = isSale ? '' : 'none';
            } else if (tab === 'limited') {
              item.style.display = isLimited ? '' : 'none';
            } else if (tab === 'new') {
              item.style.display = isNew ? '' : 'none';
            } else {
              item.style.display = '';
            }
          });
          tabBtns.forEach(function(btn) {
            var active = btn.getAttribute('data-tab') === tab;
            // Colors come from the --active class in main-product's inline CSS (pill scheme,
            // owner 2026-10-22); inline styles here would override it.
            btn.classList.toggle('related-tab-btn--active', active);
          });
          try { localStorage.setItem('relatedTabState', tab); } catch(e) {}
        }

        tabBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            applyTab(this.getAttribute('data-tab'));
            var g = document.getElementById('product-gallery');
            if (g) {
              g.style.transition = 'opacity 0.18s ease';
              g.style.opacity = '0';
              requestAnimationFrame(function() {
                requestAnimationFrame(function() { g.style.opacity = '1'; });
              });
            }
          });
        });

        var gallery = document.getElementById('product-gallery');

        // main-product leaves out tabs with no swatch to tap (owner 2026-10-24), so a category
        // can have no tab on this page; never select one that is not there.
        function hasTab(tab) {
          return Array.prototype.some.call(tabBtns, function(btn) { return btn.getAttribute('data-tab') === tab; });
        }
        function currentItem() {
          var cp = gallery ? gallery.querySelector('.current-product') : null;
          return cp ? cp.closest('.related-product-item') : null;
        }
        function leftmostCategory() {
          var it = currentItem();
          if (it) {
            if (it.getAttribute('data-bestseller') === 'true' && hasTab('bestsellers')) return 'bestsellers';
            if (it.getAttribute('data-new') === 'true' && hasTab('new')) return 'new';
            if (it.getAttribute('data-limited') === 'true' && hasTab('limited')) return 'limited';
            if (it.getAttribute('data-sale') === 'true' && hasTab('sale')) return 'sale';
          }
          return 'all';
        }
        function centerCurrent() {
          if (!gallery) return;
          var it = currentItem();
          if (!it) return;
          var gRect = gallery.getBoundingClientRect();
          var iRect = it.getBoundingClientRect();
          if (iRect.width === 0) return;
          var target = gallery.scrollLeft + (iRect.left - gRect.left) + (iRect.width / 2) - (gallery.clientWidth / 2);
          var max = gallery.scrollWidth - gallery.clientWidth;
          if (target < 0) target = 0;
          if (target > max) target = max;
          gallery.scrollLeft = target;
        }

        var navTarget = null, savedScroll = null, savedOffset = null;
        try {
          navTarget = sessionStorage.getItem('relatedNavTarget');
          savedScroll = sessionStorage.getItem('relatedGalleryScroll');
          savedOffset = sessionStorage.getItem('relatedTappedOffset');
          sessionStorage.removeItem('relatedNavTarget');
          sessionStorage.removeItem('relatedGalleryScroll');
          sessionStorage.removeItem('relatedTappedOffset');
        } catch(e) {}

        if (navTarget && navTarget === location.pathname) {
          // Arrived by clicking a swatch for a same-style product: keep the
          // selected category and the exact gallery scroll position.
          var s = null;
          try { s = localStorage.getItem('relatedTabState'); } catch(e) {}
          if (!(s === 'bestsellers' || s === 'new' || s === 'limited' || s === 'sale' || s === 'all') || !hasTab(s)) s = leftmostCategory();
          applyTab(s);
          if (savedScroll !== null && gallery) {
            var tappedOffset = savedOffset !== null ? parseFloat(savedOffset) : NaN;
            var restore = function() {
              var it = currentItem();
              if (isFinite(tappedOffset) && it && it.offsetWidth) {
                // this page's swatch goes exactly where the tapped one was
                gallery.scrollLeft += (it.getBoundingClientRect().left - gallery.getBoundingClientRect().left) - tappedOffset;
              } else {
                gallery.scrollLeft = parseInt(savedScroll, 10);
              }
            };
            restore();
            setTimeout(restore, 150);
            setTimeout(restore, 500);
          }
        } else {
          // Arrived from anywhere else (ad, collection, cart, a different-style
          // product): select the category this product belongs to (leftmost if
          // it is in several) and center this product's print in the gallery.
          applyTab(leftmostCategory());
          centerCurrent();
          setTimeout(centerCurrent, 150);
          setTimeout(centerCurrent, 500);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRelatedTabs);
      } else {
        initRelatedTabs();
      }
    })();


// [2] Reviews anchor + smooth scroll to reviews
  document.addEventListener('DOMContentLoaded', function() {
// Add an ID to the Okendo reviews section header
  let retryCount = 0;
  const MAX_RETRIES = 6;

  const addReviewsAnchor = function() {
    // Look for the Okendo reviews container - specifically targeting the header part with the stars/stats
    const reviewsHeaderContainer = document.querySelector('.oke-w-header-content-block');

    // If no header container, fall back to any Okendo container
    const reviewsContainer = reviewsHeaderContainer || document.querySelector('[data-oke-reviews-version]');

    if (!reviewsContainer) {
      // If not found yet, try again in a moment (max 10 seconds total)
      if (retryCount++ < MAX_RETRIES) {
        setTimeout(addReviewsAnchor, 500);
      }
      return;
    }
    // Create an anchor element before the reviews container
    const reviewsAnchor = document.createElement('div');
    reviewsAnchor.id = 'reviews-section';

    // Position the anchor to ensure it's at the very top of the reviews section
    reviewsAnchor.style.position = 'relative';
    reviewsAnchor.style.top = '-100px'; // Higher offset to ensure it's above the section
    reviewsAnchor.style.height = '1px';
    reviewsAnchor.style.margin = '0';
    reviewsAnchor.style.padding = '0';
    reviewsAnchor.style.pointerEvents = 'none';
    reviewsAnchor.style.visibility = 'hidden';

    // Insert the anchor before the reviews container
    reviewsContainer.parentNode.insertBefore(reviewsAnchor, reviewsContainer);
  };

  // Start the process of adding the anchor
  addReviewsAnchor();

  // Add click handlers to all rating links
  document.addEventListener('click', function(e) {
    // Check if the click was on a rating link or its children
    const ratingLink = e.target.closest('.product-rating-link');
    if (ratingLink) {
      e.preventDefault();

      // Try to find the reviews section
      const reviewsSection = document.getElementById('reviews-section');
      if (reviewsSection) {
        // Add a slight delay to ensure proper scrolling
        setTimeout(function() {
          // Scroll with an offset to account for any fixed headers
          const headerHeight = getHeaderHeight();
          const elementPosition = reviewsSection.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      } else {
        // If the reviews section isn't found yet, try to find the Okendo container directly
        const reviewsContainer = document.querySelector('.oke-w-header-content-block') ||
                                document.querySelector('[data-oke-reviews-version]');
        if (reviewsContainer) {
          setTimeout(function() {
            const headerHeight = getHeaderHeight();
            const elementPosition = reviewsContainer.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }, 100);
        } else {
          // Last resort - scroll to the bottom of the page
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        }
      }
    }
  });

  // Helper function to estimate header height (adjust based on your site)
  function getHeaderHeight() {
    // Try to find your site's header, or use a reasonable default
    const header = document.querySelector('header') || document.querySelector('.header');
    return header ? header.offsetHeight : 80; // Default to 80px if can't determine
  }
});

// [4] Character / print image toggle
document.addEventListener('DOMContentLoaded', function() {
  var toggleInput = document.getElementById('related-toggle-input');
  var characterLabel = document.getElementById('character-label');
  var printLabel = document.getElementById('print-label');
  var characterImgs = document.querySelectorAll('.product-character-img');
  var printImgs = document.querySelectorAll('.product-print-img');

  function showCharacterImages() {
    if (!toggleInput) return;
    toggleInput.checked = true;
    if (characterLabel) characterLabel.style.opacity = '1';
    if (printLabel) printLabel.style.opacity = '0.5';
    characterImgs.forEach(function(img) { img.style.opacity = '1'; });
    printImgs.forEach(function(img) { img.style.opacity = '0'; });
    try { localStorage.setItem('productToggleState', 'character'); } catch(e) {}
  }

  function showPrintImages() {
    if (!toggleInput) return;
    toggleInput.checked = false;
    if (characterLabel) characterLabel.style.opacity = '0.5';
    if (printLabel) printLabel.style.opacity = '1';
    characterImgs.forEach(function(img) { img.style.opacity = '0'; });
    printImgs.forEach(function(img) { img.style.opacity = '1'; });
    try { localStorage.setItem('productToggleState', 'print'); } catch(e) {}
  }

  // Initialize
  try {
    var storedState = localStorage.getItem('productToggleState');
    if (storedState === 'character') {
      showCharacterImages();
    } else {
      showPrintImages();
    }
  } catch(e) {
    showPrintImages();
  }

  if (toggleInput) {
    toggleInput.addEventListener('change', function() {
      if (this.checked) {
        showCharacterImages();
      } else {
        showPrintImages();
      }
    });

    toggleInput.addEventListener('mousedown', function(e) {
      e.preventDefault();
      this.blur();
      window.focus();
    });
  }

  if (characterLabel) {
    characterLabel.addEventListener('click', function() {
      showCharacterImages();
    });
  }

  if (printLabel) {
    printLabel.addEventListener('click', function() {
      showPrintImages();
    });
  }
});

// [5] Floating-character animation
    // Updated JavaScript for floating character: fade in at final position
    document.addEventListener('DOMContentLoaded', function() {
      let animationStarted = false; // Flag to prevent multiple animations

      // Only run on mobile
      if (window.innerWidth <= 749) {
        const floatingCharacter = document.getElementById('floating-character');
        const mediaWrapper = document.querySelector('.product__media-wrapper');

        if (floatingCharacter && mediaWrapper) {
          // Position the container relative to the media wrapper
          const characterContainer = document.querySelector('.floating-character-container');
          if (characterContainer) {
            mediaWrapper.style.position = 'relative';
            document.body.appendChild(characterContainer);
          }

          // Start the fade-in animation sequence only once
          if (!animationStarted) {
            animationStarted = true;

            setTimeout(function() {
              // Fade in the character
              floatingCharacter.classList.add('fade-in');

              // Start gentle floating after fade-in completes
              setTimeout(function() {
                floatingCharacter.classList.add('gentle-float');
              }, 1000); // Wait for fade-in to complete (1 second)

            }, 500); // Start sequence after 0.5 seconds
          }
        }
      }

      // Handle window resize - only reset on significant size changes
      let resizeTimer;
      let lastWidth = window.innerWidth;

      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          const currentWidth = window.innerWidth;
          const floatingCharacter = document.getElementById('floating-character');

          // Only restart if we're crossing the mobile/desktop breakpoint
          if ((lastWidth <= 749 && currentWidth > 749) || (lastWidth > 749 && currentWidth <= 749)) {
            if (floatingCharacter) {
              if (currentWidth <= 749) {
                // Reset animation flag and restart for mobile
                animationStarted = false;
                floatingCharacter.classList.remove('fade-in', 'gentle-float');

                if (!animationStarted) {
                  animationStarted = true;

                  setTimeout(function() {
                    floatingCharacter.classList.add('fade-in');

                    setTimeout(function() {
                      floatingCharacter.classList.add('gentle-float');
                    }, 1000);
                  }, 500);
                }
              }
            }
          }

          lastWidth = currentWidth;
        }, 250);
      });
    });

// [6] Keep the floating character pinned 4px below the LIVE bottom edge of the header (mobile).
//     The header is always-sticky, but the announcement bar above it scrolls away, so the header's
//     effective bottom shrinks as you scroll. We track .section-header's real viewport-bottom each
//     animation frame and set the character to position:fixed just under it.
    document.addEventListener('DOMContentLoaded', function() {
      var MOBILE_MAX = 749;
      var GAP = 10; // px below the header's bottom edge

      function getHeaderEl() {
        // .section-header is the sticky wrapper; fall back defensively.
        return document.querySelector('.section-header')
            || document.querySelector('.header-wrapper')
            || document.querySelector('header');
      }

      var headerEl = getHeaderEl();
      var ticking = false;

      function applyPosition() {
        ticking = false;
        var character = document.getElementById('floating-character');
        if (!character) return;

        // Desktop: hand positioning back to the stylesheet (character is hidden there anyway).
        if (window.innerWidth > MOBILE_MAX) {
          character.style.position = '';
          character.style.top = '';
          character.style.bottom = '';
          return;
        }

        if (!headerEl || !headerEl.isConnected) headerEl = getHeaderEl();
        var headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
        if (headerBottom < 0) headerBottom = 0;

        // Fix to the viewport, 4px under the header's current bottom edge.
        character.style.position = 'fixed';
        character.style.bottom = 'auto';
        character.style.top = Math.round(headerBottom + GAP) + 'px';
      }

      function requestApply() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(applyPosition);
        }
      }

      applyPosition();
      window.addEventListener('scroll', requestApply, { passive: true });
      window.addEventListener('resize', requestApply, { passive: true });
      window.addEventListener('load', applyPosition);
      // The sticky header measures itself (--header-height) after fonts/layout settle; re-check shortly after.
      setTimeout(applyPosition, 300);
      setTimeout(applyPosition, 1000);
    });
